import React, { useState, useEffect } from 'react';
import { Progress, Box, Text, Button, useToast } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const MadnessMeter = () => {
  const [madnessLevel, setMadnessLevel] = useState(0);
  const toast = useToast();

  useEffect(() => {
    const interval = setInterval(() => {
      setMadnessLevel((prevLevel) => {
        const newLevel = prevLevel < 100 ? prevLevel + 1 : 100;
        if (newLevel === 100) {
          clearInterval(interval);
          // Trigger toast notification when madness level is full
          toast({
            title: "Madness Overload",
            description: "You have succumbed to the madness...",
            status: "error",
            duration: 9000,
            isClosable: true,
            position: "top",
          });
        }
        return newLevel;
      });
    }, 1000); // Increase madness level every second

    return () => clearInterval(interval);
  }, [toast]);

  // Keyframes for shake animation
  const shake = keyframes`
    0% { transform: translateX(0); }
    25% { transform: translateX(-10px); }
    50% { transform: translateX(10px); }
    75% { transform: translateX(-10px); }
    100% { transform: translateX(0); }
  `;

  // Styled Box with shake animation
  const ShakingBox = styled(Box)`
    animation: ${madnessLevel >= 100 ? `${shake} 0.5s infinite` : 'none'};
  `;

  // Function to reduce madness level
  const handleSanityClick = () => {
    setMadnessLevel((prevLevel) => {
      const newLevel = prevLevel > 0 ? prevLevel - 10 : 0;
      return newLevel;
    });
  };

  return (
    <ShakingBox p={5} shadow="md" borderWidth="1px">
      <Text mb={4}>Madness Meter</Text>
      <Progress value={madnessLevel} colorScheme="red" size="lg" />
      <Button mt={4} colorScheme="blue" onClick={handleSanityClick}>
        Restore Sanity
      </Button>
      {madnessLevel >= 100 && <Text mt={4}>You have succumbed to the madness...</Text>}
    </ShakingBox>
  );
};

export default MadnessMeter;
